export default __webpack_public_path__ + "static/media/pro-elevate-lav-banner-1.593dd04b.jpg";